import { CoordsProps } from 'constants/map'

/**
 * LatLngをCoordsPropsに変換して返却する
 * @param latLng Google MapのLatLngオブジェクト
 */
export const convertToCoordsFromLatLng = (
  latLng: google.maps.LatLng
): CoordsProps => {
  return {
    lat: latLng.lat(),
    lng: latLng.lng(),
  }
}

/**
 * 住所から除外する文字列リスト
 */
const wordsToExcludeFromAddress = ((): Array<string> => {
  const src = ['日本', 'Unnamed', 'Road']
  const splitChar = src.map((e) => `${e},`)
  const splitCharSub = src.map((e) => `${e}、`)
  return [...src, ...splitChar, ...splitCharSub]
})()

/**
 * 住所から不要な文字列を削除して返却する
 * @param address Google Map Geocoderから取得した住所
 */
export const formatAddress = (address: string): string => {
  const addressList = address.split(/[、\s]/)
  if (addressList.length < 2) {
    return address
  } else {
    return addressList
      .filter((address) => !wordsToExcludeFromAddress.includes(address))
      .join(' ')
  }
}
